import React, { Fragment, useContext, useEffect } from "react";
import { AtendimentoContext } from "../../../Pages/Operacoes/Atendimento/Atendimento/AtendimentoContext";
import FormularioContato from '../FormularioContato/FormularioContato';
import FormularioCotacaoPedida from '../FormularioCotacaoPedida/FormularioCotacaoPedida';
import FormularioNegociacao from '../FormularioNegociacao/FormularioNegociacao';

const FormularioModalAtendimento = ({ filaAtendimentoId = null }) => {
  const { atendimentoValues, setAtendimentoValues, buscaProximoAtendimentoDaFila } = useContext(AtendimentoContext);
  useEffect(() => {
    buscaProximoAtendimentoDaFila(filaAtendimentoId);
  }, [filaAtendimentoId]);

  function onChangeInputTipoCotacao(event) {
    const { name, value } = event.target;
    setAtendimentoValues({
      ...atendimentoValues,
      dadosAtendimento: {
        ...atendimentoValues.dadosAtendimento,
        [name]: value
      }
    });
  }

  return (
    <Fragment>
      <div className="row align-items-end">
        <div className="col-12 col-md-8 form-group">
          <label>
            Nome Completo
          </label>
          <input
            disabled={true}
            className="form-control"
            type="text"
            name="leadNome"
            value={atendimentoValues.dadosAtendimento.lead.leadNome}
          />
        </div>
        <div className="col-12 col-md-4 form-group">
          <label>
            CPF/CNPJ
          </label>
          <input
            disabled={true}
            className="form-control"
            type="text"
            name="leadNumDocumento"
            value={atendimentoValues.dadosAtendimento.lead.leadNumDocumento}
          />
        </div>
        <div className="col-12 col-md-6 form-group">
          <label>E-mail</label>
          <input
            disabled={true}
            className="form-control"
            type="email"
            name="leadEmail"
            value={atendimentoValues.dadosAtendimento.lead.leadEmail}
          />
        </div>
        <div className="col-12 col-md-3 form-group">
          <label>Data Primeiro Contato</label>
          <input
            disabled={true}
            className="form-control"
            type="date"
            name="leadDataPrimeiroContato"
            value={atendimentoValues.dadosAtendimento.lead.leadDataPrimeiroContato}
          />
        </div>
        <div className="col-12 col-md-3 form-group">
          <label>Hora Primeiro Contato</label>
          <input
            disabled={true}
            className="form-control"
            type="time"
            name="leadHoraPrimeiroContato"
            value={atendimentoValues.dadosAtendimento.lead.leadHoraPrimeiroContato}
          />
        </div>
        <div className="col-12 col-md-12" />
        <div className="col-12 col-md-2 form-group">
          <label>DDD</label>
          <input
            disabled={true}
            className="form-control"
            type="number"
            name="leadDddTelefone"
            value={atendimentoValues.dadosAtendimento.lead.leadDddTelefone}
          />
        </div>
        <div className="col-12 col-md-4 form-group">
          <label>Telefone Fixo</label>
          <div style={{ display: "flex" }}>
            <input
              disabled={true}
              className="form-control"
              type="text"
              name="leadNumTelefone"
              value={atendimentoValues.dadosAtendimento.lead.leadNumTelefone}
            />
          </div>
        </div>
        <div className="col-12 col-md-2 form-group">
          <label>DDD</label>
          <input
            disabled={true}
            className="form-control"
            type="number"
            name="leadDddCelular"
            value={atendimentoValues.dadosAtendimento.lead.leadDddCelular}
          />
        </div>
        <div className="col-12 col-md-4 form-group">
          <label>Celular</label>
          <div style={{ display: "flex" }}>
            <input
              disabled={true}
              className="form-control"
              type="text"
              name="leadNumCelular"
              value={atendimentoValues.dadosAtendimento.lead.leadNumCelular}
            />
          </div>
        </div>
        <div className="col-12 col-md-3 form-group">
          <label>Mês de Produção</label>
          <input
            disabled={true}
            className="form-control mesano"
            type="text"
            name="leadMesAnoProducao"
            value={atendimentoValues.dadosAtendimento.lead.leadMesAnoProducao}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <ul className="nav nav-tabs" id="myTab" role="tablist">
            <li className="nav-item" role="presentation">
              <a
                className="nav-link active"
                id={"contato_tab" + filaAtendimentoId}
                data-toggle="tab"
                href={"#contato_" + filaAtendimentoId}
                role="tab"
                aria-controls={"contato_" + filaAtendimentoId}
                aria-selected="true"
              >
                Contato
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className="nav-link"
                id={"cotacao_tab" + filaAtendimentoId}
                data-toggle="tab"
                href={"#cotacao_" + filaAtendimentoId}
                role="tab"
                aria-controls={"cotacao_" + filaAtendimentoId}
                aria-selected="false"
              >
                Cotação
              </a>
            </li>
          </ul>
          <div className="tab-content" id="myTabContent">
            <div
              className="tab-pane fade show active"
              id={"contato_" + filaAtendimentoId}
              role="tabpanel"
              aria-labelledby={"contato_tab" + filaAtendimentoId}
            >
              <FormularioContato atendimentoModal={true} context={AtendimentoContext} />
            </div>
            <div className="tab-pane fade" id={"cotacao_" + filaAtendimentoId} role="tabpanel" aria-labelledby={"cotacao_tab" + filaAtendimentoId}>
              <div className="row mt-3">
                <div className="col-12 col-md-4 ml-1 form-group">
                  <label>Selecione</label>
                  <select
                    className="form-control"
                    name="tipoAtendimento"
                    onChange={onChangeInputTipoCotacao}
                    value={atendimentoValues.dadosAtendimento.tipoAtendimento}
                  >
                    <option
                      className="disabled"
                      value={atendimentoValues.tiposAtendimentoEnum.contato}
                    />
                    <option value={atendimentoValues.tiposAtendimentoEnum.perdido}>
                      Perdido
                    </option>
                    <option value={atendimentoValues.tiposAtendimentoEnum.negociacao}>
                      Negociação
                    </option>
                  </select>
                </div>
                <div className="col-12 col-md-12">
                  {atendimentoValues.dadosAtendimento.tipoAtendimento ===
                    atendimentoValues.tiposAtendimentoEnum.perdido ? (
                    <FormularioCotacaoPedida context={AtendimentoContext} />
                  ) : atendimentoValues.dadosAtendimento.tipoAtendimento ===
                    atendimentoValues.tiposAtendimentoEnum.negociacao ? (
                    <FormularioNegociacao atendimentoModal={true} context={AtendimentoContext} />
                  ) : (
                    <div className="alert alert-secondary">Escolha um processo de cotação</div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default FormularioModalAtendimento;
